module.exports = __webpack_public_path__ + "img/welcome-bg.38495b1d.jpg";